/* eslint-disable no-console */
<template>

    <div class="main_unit">
        <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
        <div v-show="!isInitLoading">
            <div class="top_unit">
                <div class="top_name_box"><div class="mgb_10">{{brandStoreName}}</div>責任者：{{adminName}}</div>
                <div class="top_center_box"> </div>
            </div>

            <div class="mgt_40 mgl_20">
                <Message v-if="ApivalidationMessage!==''" :validationMessage="alertMessage" /><br>
                <Message :validationMessage="ApivalidationMessage" />
            </div>
            <div class="wd965">
                <div class="temperature_input_display left_comment" id="displaySet">
                    <div class="temperature_lavel right_comment form-check-inline">
                        <label for="displaySet">表示データ選択</label>
                    </div>
                    <div class="form-check form-check-inline wd70">
                        <input class="form-check-input display_radio" id="displaySet_id1" name="checkdis" type="radio" value='1' v-model="temperatureSelect" @change="changeKbn($event,'check')">
                        <label class="form-check-label" for="displaySet_id1">温度</label>
                    </div>
                    <div class="form-check form-check-inline wd70">
                        <input class="form-check-input display_radio" id="displaySet_id2" name="checkdis" type="radio" value='2' v-model="temperatureSelect" @change="changeKbn($event,'check')">
                        <label class="form-check-label" for="displaySet_id2">湿度</label>
                    </div>
                    <div v-if="isStoreManager" class="form-check form-check-inline wd70">
                        <div class="input_store left_comment selectFile" id="plan">
                            <label class="selectFile__label" @click.prevent.stop="dialogOpen()">手動入力</label>
                        </div>
                    </div>
                </div>
                <div class="temperature_input_display left_comment" id="displayType">
                    <div class="temperature_lavel right_comment form-check-inline">
                        <label for="displayType">表示データ種類</label>
                    </div>
                    <div class="form-check-inline">
                        <input type="checkbox" class="mgr_15 temperature_checkBox" id="01-A" name="checkbox01" v-model="isAutoSelected" @change="changeKbn($event,'check')">
                        <label for="01-A" class="mgr_10">自動</label>
                    </div>
                    <div v-if="!munDateAciveFlg" class="form-check-inline">
                        <input type="checkbox" class="mgr_15 temperature_checkBox" id="01-C" name="checkbox01" disabled>
                        <label for="01-C" class="">手動</label>
                    </div>
                    <div v-else class="form-check-inline">
                        <input type="checkbox" class="mgr_15 temperature_checkBox" id="01-B" name="checkbox01" v-model="isMunSelected" @change="changeKbn($event,'check')">
                        <label for="01-B" class="">手動</label>
                    </div>
                </div>
                <div class="temperature_input_display left_comment mgt_20" id="selectDay">
                    <div class="temperature_lavel right_comment form-check-inline mgr_60">
                        <label for="selectDay">営業日</label>
                    </div>
                    <div class="form-check-inline mgl_15">
                        <v-date-picker ref="picker" v-model="date" mode="single"></v-date-picker>
                    </div>
                </div>
                <div class="temperature_input_display left_comment mgt_20" id="displayTime">
                    <div class="temperature_lavel right_comment form-check-inline mgr_60">
                        <label for="displayTime">表示期間</label>
                    </div>
                    <div class="form-check form-check-inline wd70">
                        <input class="form-check-input display_radio" id="displayTime_id1" name="checkTime" type="radio" value=1 v-model="timeRangeSelect" @change="changeKbn($event,'check')">
                        <label class="form-check-label" for="displayTime_id1">48時間</label>
                    </div>
                    <div class="form-check form-check-inline wd70">
                        <input class="form-check-input display_radio" id="displayTime_id2" name="checkTime" type="radio" value=2 v-model="timeRangeSelect" @change="changeKbn($event,'check')">
                        <label class="form-check-label" for="displayTime_id2">24時間</label>
                    </div>
                    <div class="form-check form-check-inline wd70">
                        <input v-if="timeRangeFlg" class="form-check-input display_radio" id="displayTime_id3" name="checkTime" type="radio" value=3 v-model="timeRangeSelect" @change="changeKbn($event,'check')">
                        <input v-else-if="!timeRangeFlg" class="form-check-input display_radio" id="displayTime_id3b" name="checkTime" type="radio" disabled>
                        <label class="form-check-label" for="displayTime_id3">12時間</label>
                    </div>
                    <div class="form-check form-check-inline wd70">
                        <input v-if="timeRangeFlg" class="form-check-input display_radio" id="displayTime_id4" name="checkTime" type="radio" value=4 v-model="timeRangeSelect" @change="changeKbn($event,'check')">
                        <input v-else-if="!timeRangeFlg" class="form-check-input display_radio" id="displayTime_id4b" name="checkTime" type="radio" disabled>
                        <label class="form-check-label" for="displayTime_id4">6時間</label>
                    </div>
                    <div class="form-check form-check-inline wd70">
                        <input v-if="timeRangeFlg" class="form-check-input display_radio" id="displayTime_id5" name="checkTime" type="radio" value=5 v-model="timeRangeSelect" @change="changeKbn($event,'check')">
                        <input v-else-if="!timeRangeFlg" class="form-check-input display_radio" id="displayTime_id5b" name="checkTime" type="radio" disabled>
                        <label class="form-check-label" for="displayTime_id5">3時間</label>
                        <ul style="padding-left: 60px;">
                            <li><input href="#" v-if="csvButtonDisabledFlg" type="button" class="btn_csv_disabled" :disabled="csvButtonDisabledFlg" value="CSV出力">
                                <input href="#" type="button" class="btn_csv" v-else value="CSV出力" @click.prevent.stop="outputCsv"></li>
                        </ul>
                    </div>
                </div>
                <div class="temperature_input_display left_comment mgt_20" id="filterSensorId">
                    <div class="temperature_lavel right_comment form-check-inline mgr_30">
                        <label for="filterSensorId">設置名称/センサーID</label>
                    </div>
                    <div class="form-check-inline mgl_15">
                        <form @submit.prevent="sensorSearch(inputSensorQuery)">
                            <input
                                class="input_sensor_filter"
                                type="text"
                                placeholder="00-12345678 もしくは 設置名称"
                                v-model="inputSensorQuery"
                            >
                            <button class="sensor_filter_btn mgl_15" type="submit">検索</button>
                            <button class="sensor_filter_btn mgl_15" type="button" @click="resetSearch">クリア</button>
                        </form>
                    </div>
                </div>
                <div class="mgt_15">
                    <div class="d-flex justify-content-start">
                      <div class="cp_ipselect_ondo cp_sl03 wd400 bg_green mgr_10">
                          <select required class="bg_green" @change="changeKbn($event,'select')">
                              <option value=0 selected>全ての種別</option>
                              <option v-for="sensorList in sensorKbnSettings" :key="sensorList.sensorKbnId" :value="sensorList.sensorKbnId" :id="sensorList.sensorKbnId">
                                  {{sensorList.sensorKbnName}}</option>
                          </select>
                      </div>
                      <div class="cp_ipselect_ondo cp_sl03 wd400 bg_green">
                        <select required class="bg_green" v-model="selectAccident" @change="changeKbn($event,'accident')">
                          <option value=0 selected>全てのデータ</option>
                          <option v-for="(accidentFlg, index) in accidentFlgList" :key="accidentFlg" :value="index+1" :id="index+1">
                            {{accidentFlg}}</option>
                        </select>
                      </div>
                    </div>
                    <div v-if="temperatureSelect==1" class="Temperature_content_box">
                        閾値 正常:{{selectKbn.lowerTemperature}}～{{selectKbn.upperTemperature}}℃
                    </div>
                    <div v-if="temperatureSelect==2" class="Temperature_content_box">
                        閾値 正常:{{selectKbn.lowerHumidity}}～{{selectKbn.upperHumidity}}%
                    </div>
                    <div v-if="reload" class="Temperature_content_box">
                        <TemperatureChart :style="newHeight" :chart-data="senserData" :options="options"></TemperatureChart>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showContent">
            <div>
                <div class="modal_box wd800">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit_s"> </p>
                            <p class="modal_header_tit">グラフデータ</p>
                        </div>
                        <div class="modal_header_left">
                            <a class="js-modal-close" role="button" @click.prevent.stop="dialogClose">閉じる</a>
                        </div>
                    </div>
                    <div class="wd700 mgt_20">
                        <div class="modal_content_tit">手動入力</div>
                        <div class="lavel_error_font mgb_5">{{validationModelMessage}}</div>
                        <div class="dialog_ondo_unit">
                            <p class="dialog_ondo_tit">種別</p>
                            <td class="dialog_background-color_def dialog_select_wd">
                                <div class="cp_ipselect cp_sl01">
                                    <select class="dialog_select_area" @change="changeDialogKbn($event)" v-model="SelectValueDialog">
                                        <option value="" disabled>種別を選択</option>
                                        <option v-for="sensorList in sensorKbnSettings" :key="sensorList.sensorKbnId" :value="sensorList.sensorKbnId" :id="sensorList.sensorKbnId">
                                            {{sensorList.sensorKbnName}}</option>
                                    </select>
                                </div>
                            </td>
                        </div>
                        <div class="dialog_ondo_unit">
                            <p class="dialog_ondo_tit_senser">センサー</p>
                            <td v-if="SelectValueDialog==''" class="dialog_background-color_disabled dialog_select_wd">
                                <div class="cp_ipselect cp_sl01">
                                    <select class="dialog_select_area" disabled >
                                        <option value="" hidden>センサーを選択</option>
                                    </select>
                                </div>
                            </td>
                            <td v-else class="dialog_background-color_def dialog_select_wd">
                                <div class="cp_ipselect cp_sl01">
                                    <select class="dialog_select_area" v-model="SelectValueSenser">
                                        <option value="" disabled>センサーを選択</option>
                                        <option v-for="sensorList in senserSettingsParm" :key="sensorList.sensorId" :value="sensorList.sensorId" :id="sensorList.sensorId">
                                            {{sensorList.location}}:{{sensorList.sensorId}}</option>
                                    </select>
                                </div>
                            </td>
                        </div>

                        <div class="dialog_ondo_unit_day">
                            <p class="dialog_ondo_tit_senser">営業日:</p>
                            <p class="time_ondo_tit">{{dialogBusinessDay}}</p>
                        </div>
                        <div class="time_ondo_unit">
                            <div class="time_ondo_box">
                                <p class="time_ondo_tit">計測時刻</p>
                                <vue-timepicker v-model="senserInputDataMeasurementtime" @close="onCloseSensorTimePicker"></vue-timepicker>
                            </div>
                            <div class="time_ondo_box">
                                <p class="time_ondo_tit">温度</p>
                                <input type="text" class="textarea_ondo" placeholder="00.0" v-model="senserInputDataTemperature" maxlength="5">
                                <p class="time_ondo_tit">℃</p>
                            </div>
                            <div class="time_ondo_box">
                                <p class="time_ondo_tit">湿度</p>
                                <input type="text" class="textarea_ondo" placeholder="00.0" v-model="senserInputDatahumidity" maxlength="5">
                                <p class="time_ondo_tit">％</p>
                            </div>
                        </div>
                        <div v-if="isStoreManager" class="dialog_ondo_unit">
                            <p class="dialog_ondo_tit_senser">スタッフ名:</p>
                            <p class="time_ondo_tit">{{staffName}}</p>
                        </div>
                    </div>
                    <div class="btn_submit letter_spa">
                        <a role="button" @click.prevent.stop="dialogOpenCheck()">登録</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showContent2">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">グラフデータ</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>登録が完了しました。</p>
                    </div>

                    <div class="btn_submit">
                        <a href="#" @click.prevent.stop="closeModel">OK</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showContent3">
            <div>
                <div class="modal_box wd600">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">グラフデータ 登録確認</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>手動データの登録を実施します。よろしいですか？</p><br><br>
                        <p>種別：{{sensorKbnName}}</p>
                        <p>設置名称・備考：{{senserLocation}}</p>
                        <p>センサー：{{SelectValueSenser}}</p>
                        <p>営業日：{{dialogBusinessDay}}</p>
                        <p>時刻：{{senserInputDataMeasurementtime}}</p>
                        <p v-if="senserInputDataTemperature!==''">温度：{{senserInputDataTemperature}}℃</p>
                        <p v-if="senserInputDatahumidity!==''">湿度：{{senserInputDatahumidity}}％</p>
                    </div>

                    <div class="btn_submit_box">
                        <div class="btn_submit2">
                            <a role="button" @click.prevent.stop="dialogCloseCheck">キャンセル</a>
                        </div>
                        <div class="btn_submit">
                            <a role="button" @click.prevent.stop="inputSenserData(0,'input')">登録</a>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="overlay_loder2" v-show="isLoading">
            <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        </div>

        <div class="overlay" v-show="showContent4">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">CSV出力</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>CSV出力が完了しました。</p>
                    </div>
                    <div class="btn_submit">
                        <a href="#" @click.prevent.stop="closeModel1">OK</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import TemperatureChart from '@/app/components/TemperatureChart.vue'
    import PulseLoader from '@/app/components/PulseLoader.vue'
    import Message from '@/app/components/Message.vue'
    import VueTimepicker from 'vue2-timepicker'
    import 'vue2-timepicker/dist/VueTimepicker.css'

export default {
    name: 'TemperatureList',
    components: {
        TemperatureChart,
        PulseLoader,
        Message,
        VueTimepicker
    },
    data: function () {
        return {
            reload:true,
            upperDataString:"",
            lowerDataString:"",
            timeRangeFlg:true,
            date:null,
            munDateAciveFlg:true,
            isAutoSelected:true,
            isMunSelected:true,
            sensorKbnName:"",
            nowSendDate:"",
            senserSettingsParm:null,
            dialogBusinessDay:"",
            sensorKbnSettingsValue:null,
            validationModelMessage:"",
            SelectValueSenser:"",
            senserLocation:"",
            SelectValueDialog:"",
            senserInputDataMeasurementtime: '00:00', // ここはオブジェクトにしてはいけない
            senserInputDataTemperature:'',
            senserInputDatahumidity:'',
            showContent:false,
            showContent2:false,
            showContent3:false,
            showContent4:false,
            selectValue:0,
            temperatureSelect:1,
            temperatureType:1,
            timeRangeSelect:2,
            isLoading:false,
            isInitLoading:true,
            ApivalidationMessage:'',
            alertMessage:'入力エラーがあります。',
            brandId: '',
            storeId: '',
            senserData:null,
            selectKbn:{
                'upperTemperature':'',
                'lowerTemperature':'',
                'lowerHumidity':'',
                'upperHumidity':'',
            },
            //温度湿度管理一覧取得
            sensorData: [],
            //機器閾値情報取得
            sensorKbnSettings: [],
            senserCloarSetting:[
                '#ff0000',
                '#0000ff',
                '#e0e000',
                '#008000',
                '#00ffff',
                '#ffa500',
                '#800080',
                '#c00000',
                '#0000c0',
                '#808000',
                '#004000',
                '#00C0C0',
                '#c07500',
                '#c000c0',
                '#c0c0c0',
            ],
            options: {
                chartArea:{
                  backgraundColor: '#fff'
                },
                legend:{
                    display:true,
                    position:'bottom',
                    labels:{
                        filter:function(chartData){
                             return chartData.text != 'upper' && chartData.text != 'lower'
                        }
                    },
                    onClick: function (e, legendItem) {
                      const index = legendItem.datasetIndex;
                      var chart = this.chart;
                      var allHidden = true;
                      var isHidden = chart.data.datasets[index].hidden;

                      var isAllVisible = false;
                      // データ種別が「全て」かどうか
                      var selectKbnAll = false;
                      const seen = new Set();
                      for(var i=0; i < chart.data.datasets.length ; i++) {
                        seen.add(chart.data.datasets[i].sensorKbnId);
                        if(seen.size > 1) {
                          selectKbnAll = true;
                          break;
                        }
                      }

                      // クリックしたデータが非表示の場合
                      if(isHidden){
                        // その他のデータは非表示
                        allHidden = true;
                      } else {
                        // クリックしたデータが表示の場合
                        // データ種別が「全て」の場合
                        if(selectKbnAll){
                          isAllVisible = chart.data.datasets.every(function (dataset) {
                            if(dataset.label == 'upper' || dataset.label == 'lower') {
                              return true
                            } else {
                              return !dataset.hidden;
                            }
                          });
                        } else {
                          // データ種別が「全て」以外の場合
                          isAllVisible = chart.data.datasets.every(function (dataset) {
                            return !dataset.hidden;
                          });
                        }

                        if(isAllVisible) {
                          allHidden = true;
                        } else {
                          allHidden = false;
                        }
                      }
                      // 全てのデータセットの表示非表示
                      if(selectKbnAll){
                        //全てを表示
                        chart.data.datasets.forEach(function (dataset){
                          if(dataset.label == 'upper' || dataset.label == 'lower') {
                            dataset.hidden = true;
                          } else {
                            dataset.hidden = allHidden;
                          }
                          if(isAllVisible || isHidden){
                            // chart.data.datasets.forEach(function (dataset) {
                              if(dataset.label == 'upper' || dataset.label == 'lower') {
                                if(chart.data.datasets[index]["sensorKbnId"] === dataset["sensorKbnId"]){
                                  dataset.hidden = false;
                                }
                              }
                            // });
                          }
                        });
                      } else {
                        //全てを表示
                        chart.data.datasets.forEach(function (dataset) {
                          dataset.hidden = allHidden;
                          if(dataset.label == 'upper' || dataset.label == 'lower') {
                            if(chart.data.datasets[index]["sensorKbnId"] === dataset["sensorKbnId"]){
                              dataset.hidden = false;
                            }
                          }
                        });
                      }

                      // クリックしたデータセットを表示
                      chart.data.datasets[index].hidden = false;
                      chart.update();
                    },
                },
                scales: {
                    xAxes: [{
                        scaleLabel: {
                            display: true,
                        },
                        type:'time',
                        time:{
                            parser: "YYYY/MM/DD hh:mm",
                            tooltipFormat:"DD日 hh:mm A",
                            displayFormats:{
                                minute: 'h:mm a'
                            },
                            unit:'hour'
                        },
                        ticks: {
                            min: "",
                            max: ""
                        },
                    }],
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            stepSize: 1
                        }
                    }]
                },
                tooltips: {
                    enabled: true,
                    callbacks: {
                        beforeLabel: function(tooltipItem, data) {
                            return data.datasets[tooltipItem.datasetIndex].location[tooltipItem.index];
                        },
                        label:function(tooltipItem,data){
                            return data.datasets[tooltipItem.datasetIndex].sensorId[tooltipItem.index] + " " + tooltipItem.yLabel +
                                data.datasets[tooltipItem.datasetIndex].selectUnit[tooltipItem.index];
                        },
                        afterLabel: function(tooltipItem,data){
                            if(data.datasets.staffName != '') {
                                return data.datasets[tooltipItem.datasetIndex].staffName[tooltipItem.index];
                            }
                        }
                    }
                },
                maintainAspectRatio:false,
                onClick: function (event) {
                  var chart = this.chart;
                  //選択したデータポイントを取得
                  var points = chart.getElementsAtEventForMode(event, 'nearest', { intersect: true}, true);
                  if(points.length === 0) {
                    return;
                  }
                  var point = points[0];
                  var datasetIndex = point['_datasetIndex'];
                  //選択したデータの種別を取得
                  var selectKbnId = point['_chart'].data.datasets[0].sensorKbnId;
                  var selectKbnAll = false;
                  const seen = new Set();
                  for(var i=0; i < chart.data.datasets.length ; i++) {
                    seen.add(chart.data.datasets[i].sensorKbnId);
                    if(seen.size > 1) {
                      selectKbnAll = true;
                      break;
                    }
                  }
                  //選択済みのデータの判定
                  var isAllVisible = false;
                  if(selectKbnAll){
                    isAllVisible = chart.data.datasets.every(function (dataset) {
                      if(dataset.label == 'upper' || dataset.label == 'lower') {
                        return true
                      } else {
                        return !dataset.hidden;
                      }
                    });
                  } else {
                    isAllVisible = chart.data.datasets.every(function (dataset) {
                      return !dataset.hidden;
                    });
                  }
                  //選択済みのデータが無い場合
                  if(isAllVisible) {
                    //選択したデータのみ表示
                    chart.data.datasets.forEach(function (dataset, i){
                      if(dataset.label != 'upper' && dataset.label != 'lower') {
                        dataset.hidden = i !== datasetIndex;
                      }
                      //選択したデータの種別のみ閾値表示
                      else {
                        dataset.hidden = selectKbnId !== dataset["sensorKbnId"];
                      }
                    });
                  }
                  //選択済みのデータがある場合
                  else {
                    if(selectKbnAll){
                      //全てを表示
                      chart.data.datasets.forEach(function (dataset){
                        if(dataset.label == 'upper' || dataset.label == 'lower') {
                          dataset.hidden = true;
                        } else {
                          dataset.hidden = false;
                        }
                      });
                    } else {
                      //全てを表示
                      chart.data.datasets.forEach(function (dataset){
                        dataset.hidden = false;
                      });
                    }
                  }
                  chart.update();
                },
                plugins: {
                    datalabels: {
                        //プロット上のデータラベル非表示
                        display: false
                    }
                },
            },
            csvButtonDisabledFlg:true,
            baseHeight: 600,
            height:600,
            accidentFlgList:["データ欠落","温湿度異常"],
            tempSenserData: null,
            selectAccident:0,
            inputSensorQuery:'',
        }
    },
    computed: {
        brandPath: function () {
            return this.$store.getters['brand/path']
        },
        adminName: function () {
            return this.$store.getters['store/adminName']
        },
        staffName: function (){
            return this.$store.getters['staff/name']
        },
        staffId: function (){
            return this.$store.getters['staff/staffId']
        },
        brandStoreName: function () {
            let brandName = this.$store.getters['brand/name']
            let storeName = this.$store.getters['store/name']

            if (brandName == null) {
                brandName = ''
            }

            if (storeName == null) {
                storeName = ''
            }

            return brandName + '・' + storeName
        },
        newHeight() {
          return {
            height: `${this.height}px`,
            position: 'relative'
          }
        },
        isStoreManager: function () {
          let storeId = this.$store.getters['store/id'];
          // 店舗情報を取得していない場合
          if (storeId === null || ! this.$cookies.get('user-api-token')) {
            return false
          }
          return true;
        }
    },
    created: function(){
        this.date = new Date(this.chartDateBusinessDay(new Date()));
        let to = new Date();
        let from = new Date();
        from.setDate(from.getDate() - 1);

        this.setCharXAxes(from, to);
        this.calc();
    },
    methods: {
        async calc(){
            // ブランドIDを取得
            this.brandId = this.$store.getters['brand/id'];
            // ストアIDを取得
            this.storeId = this.$store.getters['store/id'];
            this.ApivalidationMessage = '';
            var apiResponseFlg = true;

            var datetime = this.dateFormat();

            // 表示データ種別のパラメータ変換
            var autoSelected = 1;
            var munSelected = 1;
            var selectBusinessDay = this.selectDateFormat(this.date);
            var url = this.$apiEndpoint + 'manage/brand/' + this.brandId + '/store/' + this.storeId + '/temperature_humidity?range=1'+ '&datetime=' + datetime + '&type=' + this.temperatureSelect
                + '&automatic_type=' + autoSelected + '&manual_type=' + munSelected + '&range=' + this.timeRangeSelect + '&businessday=' + selectBusinessDay;
            if(this.isStoreManager){
              url = this.$apiEndpoint + 'user/brand/' + this.brandId + '/store/' + this.storeId + '/temperature_humidity?range=1'+ '&datetime=' + datetime + '&type=' + this.temperatureSelect
                  + '&automatic_type=' + autoSelected + '&manual_type=' + munSelected + '&range=' + this.timeRangeSelect + '&businessday=' + selectBusinessDay;
            }
            // 温度湿度管理一覧取得API
            await this.$axios
                .get(url)
                .then(response => {
                  this.sensorKbnSettings = response.data.sensorKbnSettingList;
                  this.sensorData = response.data.sensorList;
                })
                .catch((err) => {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}
                    apiResponseFlg = false;
                    if (err.customError) {
                      error = Object.assign(error, err.customError);

                      if(error.code == 400){
                        this.ApivalidationMessage =  error.message;
                        this.scrollTop();
                      }
                    }
                    if(error.code !== 400){
                      this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }
                }).finally(()=> this.isInitLoading = false);
            // API処理判定
            if(apiResponseFlg){
              this.dataSet(0);
            }
        },
        async changeKbn(event,action){

            // 操作の判定
            var URL = '';
            if(action == "select"){
                this.selectValue = event.target.value;
                this.selectAccident = 0;
            }
            else if(action == "check"){
                // 種別選択がない場合、処理停止
                if(this.selectValue == 0 && this.isInitLoading){
                    return;
                }
            }
            else if(action == "accident"){

              var dataSetsListObj = new Object();
              dataSetsListObj['labels'] = [];

              // データ欠落選択
              if(event.target.value == 1){
                dataSetsListObj['datasets'] = this.tempSenserData['datasets'].filter(e => e['sensorAccidentFlg'] == 1);
              }
              // 温湿度異常選択
              else if(event.target.value == 2){
                dataSetsListObj['datasets'] = this.tempSenserData['datasets'].filter(e => e['temperatureAccidentFlg'] == 1);
              }
              // フィルター無
              else {
                dataSetsListObj['datasets'] = this.tempSenserData['datasets'];
              }
              this.senserData = dataSetsListObj;
              return;
            }

            this.isLoading = true;
            var datetime = this.dateFormat();

            this.ApivalidationMessage = '';
            var apiResponseFlg = true;

            // 表示データ種別のパラメータ変換
            var autoSelected = 1;
            var munSelected = 1;

            // バリデーションチェック
            var selectBusinessDay = "";
            var nowBusinessDay = "";
            // 営業日の未来日付のチェック
            if(this.date !== null){
                selectBusinessDay = this.selectDateFormat(this.date);
                nowBusinessDay = this.chartDateBusinessDay(new Date());
                // 未来の営業日を選択している場合
                if(selectBusinessDay > nowBusinessDay){
                    this.ApivalidationMessage="未来の営業日は選択できません。";
                    this.isLoading = false;
                    this.scrollTop();
                    return ;
                }

                var toDate = new Date()
                toDate.setDate(toDate.getDate()-365);
                var oneYearAgoDate = this.chartDateBusinessDay(toDate);
                if(oneYearAgoDate > selectBusinessDay){
                    this.ApivalidationMessage="1年以上前の営業日は選択できません。";
                    this.isLoading = false;
                    this.scrollTop();
                    return ;
                }
            }

            if(this.selectValue == 0){
              URL = this.$apiEndpoint + 'manage/brand/' + this.brandId + '/store/' + this.storeId
                  + '/temperature_humidity?range=1' + '&datetime=' + datetime + '&type=' + this.temperatureSelect
                  + '&automatic_type=' + autoSelected + '&manual_type=' + munSelected + '&range=' + this.timeRangeSelect;
              if(this.isStoreManager) {
                URL = this.$apiEndpoint + 'user/brand/' + this.brandId + '/store/' + this.storeId
                    + '/temperature_humidity?range=1' + '&datetime=' + datetime + '&type=' + this.temperatureSelect
                    + '&automatic_type=' + autoSelected + '&manual_type=' + munSelected + '&range=' + this.timeRangeSelect;

              }
            } else {
              URL = this.$apiEndpoint + 'manage/brand/' + this.brandId + '/store/' + this.storeId
                  + '/temperature_humidity?sensor_kbn_setting_id=' + this.selectValue + '&datetime=' + datetime + '&type=' + this.temperatureSelect
                  + '&automatic_type=' + autoSelected + '&manual_type=' + munSelected + '&range=' + this.timeRangeSelect;
              if(this.isStoreManager) {
                URL = this.$apiEndpoint + 'user/brand/' + this.brandId + '/store/' + this.storeId
                    + '/temperature_humidity?sensor_kbn_setting_id=' + this.selectValue + '&datetime=' + datetime + '&type=' + this.temperatureSelect
                    + '&automatic_type=' + autoSelected + '&manual_type=' + munSelected + '&range=' + this.timeRangeSelect;

              }
            }

            if(this.date !== null){
                URL = URL + '&businessday=' + selectBusinessDay;
            }

            // 温度湿度管理一覧取得API
            await this.$axios
                .get(URL)
                .then(response => {
                    this.sensorKbnSettings = response.data.sensorKbnSettingList;
                    this.sensorData = response.data.sensorList;
                })
                .catch((err) => {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}
                    apiResponseFlg = false;
                    if (err.customError) {
                        error = Object.assign(error, err.customError);

                        if(error.code == 400){
                            this.ApivalidationMessage =  error.message;
                            this.scrollTop();
                        }
                    }
                    if(error.code !== 400){
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }
                }).finally(()=> this.isLoading = false);

            // API処理判定
            if(apiResponseFlg){
                this.dataSet(this.selectValue);
            }

            this.csvButtonDisabled(this.csvButtonDisabledFlg);

        },
        async dataSet(selectValue){

            var dataSetsList = [];
            var dataSetsListObj = new Object();

            var count =0;
            var allLabelLength = 0;
            var munDateAcive = false;
            var cloerCount = 0; // 色選択用カウント

            // グラフ再描画の為、表示フラグをOFFにする
            this.reload = false;

            // 表示単位の設定
            var selectUnit = "";
            if(this.temperatureSelect == 1){
                selectUnit = "℃";
            }
            else{
                selectUnit = "％";
            }
            this.fromToDataSet();
            for(var i = 0 ;i < this.sensorData.length ; i++){

                // 手動データの有無をチェック
                if(this.sensorData[i].sensorId.indexOf('手動') != -1){
                    // 手動にチェックがある場合
                    munDateAcive = true;
                }

                // データ種別の選択状況を判定
                if(!this.isAutoSelected && this.sensorData[i].sensorId.indexOf('自動') > -1){
                    // 自動データでかつ自動にチェックがない場合、スキップする
                    continue;
                }
                else if(!this.isMunSelected && this.sensorData[i].sensorId.indexOf('手動') > -1){
                    // 手動データでかつ手動にチェックがない場合、スキップする
                    continue;
                }

                for (let indexOfData in this.sensorData[i].sensorHistoryList) {
                    var dataLst = new Object();
                    var dataByLocation = this.sensorData[i].sensorHistoryList[indexOfData]
                    var dataDisList = [];
                    var dataDisList2 = [];
                    var dataDisList3 = [];
                    var dataDisList4 = [];
                    var dataDisList5 = [];
                    var locationStr = "";
                    var temperatureAccidentFlg = 0;
                    var sensorAccidentFlg = 0;


                    let selectedSensorKbnSettings = this.sensorKbnSettings.filter(item => item['sensorKbnId'] == this.sensorData[i].sensorKbnId);
                    for(var k =0 ; k < dataByLocation.length ; k++){
                        var oj = new Object();
                        var dataByLocationObj = dataByLocation[k];
                        oj['x'] = dataByLocationObj.detectionDate;
                        // データ欠落をしているか
                        var fromDate =  new Date();
                        var toDate = new Date();
                        //最初のデータの場合グラフ開始時刻から15分以上経過していたらデータ欠落
                        if(k == 0){
                          fromDate = this.lowerDataString;
                          toDate = dataByLocation[k].detectionDate
                        }
                        //最後のデータの場合
                        else if(k == dataByLocation.length-1){
                          fromDate = dataByLocation[k].detectionDate;
                          //営業日が当日の場合、現在時刻と比較して15分以上経過していたらデータ欠落
                          //当日以外の場合、グラフ終了時刻と比較して15分以上経過していたらデータ欠落
                          if(!this.isToday()){
                            toDate = this.upperDataString;
                          }
                        }
                        else {
                          fromDate = dataByLocation[k].detectionDate;
                          toDate = dataByLocation[k-1].detectionDate;
                        }
                        //データ欠落があるかどうか
                        if(this.isTimeEarlier(fromDate, toDate)){
                          sensorAccidentFlg = 1;
                        }
                        if(this.temperatureSelect == 1){
                            oj['y'] = dataByLocationObj.temperature;
                            //温度異常があるか
                            if(oj['y'] > parseFloat(selectedSensorKbnSettings[0].upperTemperature) || oj['y'] < parseFloat(selectedSensorKbnSettings[0].lowerTemperature)) {
                              temperatureAccidentFlg = 1;
                            }
                        }
                        else{
                            oj['y'] = dataByLocationObj.humidity;
                            //湿度異常があるか
                            if(oj['y'] > parseFloat(selectedSensorKbnSettings[0].upperHumidity) || oj['y'] < parseFloat(selectedSensorKbnSettings[0].lowerHumidity)) {
                              temperatureAccidentFlg = 1;
                            }
                        }
                        dataDisList[k] = oj;
                        dataDisList2[k] = dataByLocationObj.location;
                        dataDisList3[k] = this.sensorData[i].sensorId;
                        dataDisList4[k] = selectUnit;
                        dataDisList5[k] = dataByLocationObj.staffName;
                        locationStr = dataByLocationObj.location;
                    }

                    dataLst['label'] = locationStr + ":" + this.sensorData[i].sensorId;
                    dataLst['data'] = dataDisList;
                    dataLst['location']= dataDisList2;
                    dataLst['sensorId']= dataDisList3;
                    dataLst['selectUnit']= dataDisList4;
                    dataLst['staffName'] = dataDisList5;
                    dataLst['sensorKbnId'] = this.sensorData[i].sensorKbnId;
                    dataLst['temperatureAccidentFlg'] = temperatureAccidentFlg;
                    dataLst['sensorAccidentFlg'] = sensorAccidentFlg;
                    // センサーカウント15を超えた場合、配色にカウントを戻す
                    if(cloerCount >= 15){
                        cloerCount = 0;
                    }
                    dataLst['borderColor'] = this.senserCloarSetting[cloerCount];

                    if(this.isMunSelected && this.sensorData[i].sensorId.indexOf('手動') > -1){
                        // 手動データでかつ手動にチェックがある場合、破線を設定
                        dataLst['borderDash'] = [4,2];
                    }

                    dataLst['borderWidth'] =1;
                    dataLst['lineTension'] =0;
                    dataLst['fill'] =false;
                    dataLst['hidden'] = false;
                    dataSetsList[count] = dataLst;
                    count = count + 1;
                    cloerCount = cloerCount + 1;
                    allLabelLength = allLabelLength + dataLst['label'].length;
                }
            }

            // 手動データのチェックボックスの制御
            this.munDateAciveFlg = munDateAcive;
            if(!munDateAcive){
                // 手動データの非活性に合わせて、手動チェックボックスのチェックを外す
                this.isMunSelected = false;
            }

            // 営業日からグラフ表示のy軸を設定

            var selectedSensorKbnSettings = this.sensorKbnSettings;
            if(selectValue != 0){
              selectedSensorKbnSettings = this.sensorKbnSettings.filter(item => item['sensorKbnId'] == selectValue);
            }
            var maxUpperTemperature = parseFloat(selectedSensorKbnSettings[0].upperTemperature);
            var minLowerTemperature = parseFloat(selectedSensorKbnSettings[0].lowerTemperature);
            var maxUpperHumidity = parseFloat(selectedSensorKbnSettings[0].upperHumidity);
            var minLowerHumidity = parseFloat(selectedSensorKbnSettings[0].lowerHumidity);
            for(var p=0; p < selectedSensorKbnSettings.length; p++) {

              //閾値用のデータを設定
              var dataLstWW = new Object();
              dataLstWW['label'] = 'lower';
              if (this.temperatureSelect == 1) {
                dataLstWW['data'] = [{
                  'x': this.lowerDataString,
                  'y': parseFloat(selectedSensorKbnSettings[p].lowerTemperature)
                }, {'x': this.upperDataString, 'y': parseFloat(selectedSensorKbnSettings[p].lowerTemperature)},];
                if(minLowerTemperature > parseFloat(selectedSensorKbnSettings[p].lowerTemperature)){
                  minLowerTemperature = parseFloat(selectedSensorKbnSettings[p].lowerTemperature);
                }
              } else {
                dataLstWW['data'] = [{
                  'x': this.lowerDataString,
                  'y': parseFloat(selectedSensorKbnSettings[p].lowerHumidity)
                }, {'x': this.upperDataString, 'y': parseFloat(selectedSensorKbnSettings[p].lowerHumidity)},];
                if(minLowerHumidity > parseFloat(selectedSensorKbnSettings[p].lowerHumidity)){
                  minLowerHumidity = parseFloat(selectedSensorKbnSettings[p].lowerHumidity);
                }
              }

              dataLstWW['borderColor'] = 'rgba(30,144,255,1)';
              dataLstWW['borderWidth'] = 2;
              dataLstWW['lineTension'] = 0;
              dataLstWW['pointRadius'] = 0;
              dataLstWW['fill'] = false;
              dataLstWW['hidden'] = selectValue == 0;
              dataLstWW['sensorKbnId'] = selectedSensorKbnSettings[p].sensorKbnId;
              dataLstWW['temperatureAccidentFlg'] = 1;
              dataLstWW['sensorAccidentFlg'] = 1;
              dataSetsList[count] = dataLstWW;

              count = count + 1;
              var dataLstRR = new Object();
              dataLstRR['label'] = 'upper';
              if (this.temperatureSelect == 1) {
                dataLstRR['data'] = [{
                  'x': this.lowerDataString,
                  'y': parseFloat(selectedSensorKbnSettings[p].upperTemperature)
                }, {'x': this.upperDataString, 'y': parseFloat(selectedSensorKbnSettings[p].upperTemperature)},];
                if(maxUpperTemperature < parseFloat(selectedSensorKbnSettings[p].upperTemperature)){
                  maxUpperTemperature = parseFloat(selectedSensorKbnSettings[p].upperTemperature);
                }
              } else {
                dataLstRR['data'] = [{
                  'x': this.lowerDataString,
                  'y': parseFloat(selectedSensorKbnSettings[p].upperHumidity)
                }, {'x': this.upperDataString, 'y': parseFloat(selectedSensorKbnSettings[p].upperHumidity)},];
                if(maxUpperHumidity < parseFloat(selectedSensorKbnSettings[p].upperHumidity)){
                  maxUpperHumidity = parseFloat(selectedSensorKbnSettings[p].upperHumidity);
                }
              }
              dataLstRR['borderColor'] = 'rgba(255, 20, 147, 1)';
              dataLstRR['borderWidth'] = 2;
              dataLstRR['lineTension'] = 0;
              dataLstRR['pointRadius'] = 0;
              dataLstRR['fill'] = false;
              dataLstRR['hidden'] = selectValue == 0;
              dataLstRR['sensorKbnId'] = selectedSensorKbnSettings[p].sensorKbnId;
              dataLstRR['temperatureAccidentFlg'] = 1;
              dataLstRR['sensorAccidentFlg'] = 1;
              dataSetsList[count] = dataLstRR;
              count = count + 1;
            }

            dataSetsListObj['labels'] = [];
            dataSetsListObj['datasets'] = dataSetsList;

            //閾値設定
            this.selectKbn['upperTemperature'] = maxUpperTemperature
            this.selectKbn['lowerTemperature'] = minLowerTemperature
            this.selectKbn['upperHumidity'] = maxUpperHumidity
            this.selectKbn['lowerHumidity'] = minLowerHumidity
            this.senserData = dataSetsListObj;
            this.tempSenserData = this.senserData;
            if(allLabelLength <= 0) {
              this.height = this.baseHeight;
            } else {
              this.height = this.baseHeight + ((allLabelLength/70)*25);
            }
            // 描画完了まで待機
            await this.$nextTick();
            // グラフ再描画の為、表示フラグをONにする
            this.reload = true;
        },
        dateFormat(){
            let nowDate = new Date();
            let year = nowDate.getFullYear();
            let month = ("0" + (nowDate.getMonth()+1)).slice(-2);
            let day = ("0" + nowDate.getDate()).slice(-2);
            let hours = ("0" + nowDate.getHours()).slice(-2);
            let minutes = ("0" + nowDate.getMinutes()).slice(-2);
            let seconds = ("0" + nowDate.getSeconds()).slice(-2);

            let format_str = 'YYYYMMDDhhmmss'
            format_str = format_str.replace(/YYYY/g,year);
            format_str = format_str.replace(/MM/g,month);
            format_str = format_str.replace(/DD/g,day);
            format_str = format_str.replace(/hh/g,hours);
            format_str = format_str.replace(/mm/g,minutes);
            format_str = format_str.replace(/ss/g,seconds);
            return format_str;
        },
        dateFormat_Temperture() {

            this.nowSendDate = "";
            let nowDate = new Date();
            var measurementTime = this.senserInputDataMeasurementtime;

            let year = nowDate.getFullYear();
            let month = ("0" + (nowDate.getMonth()+1)).slice(-2);
            let day = ("0" + nowDate.getDate()).slice(-2);
            let hours = measurementTime.substr(0,2);
            let minutes = measurementTime.substr(3,2);
            let seconds = ("00");

            let format_str = 'YYYYMMDDhhmmss'
            format_str = format_str.replace(/YYYY/g, year);
            format_str = format_str.replace(/MM/g, month);
            format_str = format_str.replace(/DD/g, day);
            format_str = format_str.replace(/hh/g, hours);
            format_str = format_str.replace(/mm/g, minutes);
            format_str = format_str.replace(/ss/g, seconds)

            this.nowSendDate = format_str;

            return format_str;
        },
        setCharXAxes(fromDate, toDate){
            this.options.scales.xAxes[0].ticks.min = this.chartDateFormat(fromDate);
            this.options.scales.xAxes[0].ticks.max = this.chartDateFormat(toDate);
        },
        chartDateFormat(date){
            let year = date.getFullYear();
            let month = ("0" + (date.getMonth()+1)).slice(-2);
            let day = ("0" + date.getDate()).slice(-2);
            let hours = ("0" + date.getHours()).slice(-2);
            let minutes = ("0" + date.getMinutes()).slice(-2);

            let format_str = 'YYYY/MM/DD hh:mm';
            format_str = format_str.replace(/YYYY/g,year);
            format_str = format_str.replace(/MM/g,month);
            format_str = format_str.replace(/DD/g,day);
            format_str = format_str.replace(/hh/g,hours);
            format_str = format_str.replace(/mm/g,minutes);

            return format_str;
        },
        selectDateFormat(date){
            let year = date.getFullYear();
            let month = ("0" + (date.getMonth()+1)).slice(-2);
            let day = ("0" + date.getDate()).slice(-2);

            let format_str = 'YYYY/MM/DD';
            format_str = format_str.replace(/YYYY/g,year);
            format_str = format_str.replace(/MM/g,month);
            format_str = format_str.replace(/DD/g,day);

            return format_str;
        },
        scrollTop() {
            window.scrollTo(0, 0);
        },
        async dialogOpen() {

            // ダイアログ表示、センサー情報の取得
            this.isLoading = true;
            this.ApivalidationMessage = '';
            var apiResponseFlg = true;

            // 機器一覧取得API呼び出し
            await this.$axios
                .get(this.$apiEndpoint + 'user/brand/' + this.brandId + '/store/' + this.storeId + '/sensor/setting')
                .then(response => {
                    this.sensorKbnSettingsValue = response.data.sensorKbnSettings;
                })
                .catch((err) => {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}
                    apiResponseFlg = false;
                    if (err.customError) {
                        error = Object.assign(error, err.customError);

                        if(error.code == 400){
                            this.ApivalidationMessage =  error.message;
                            this.scrollTop();
                        }
                    }
                    if(error.code !== 400){
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }
                }).finally(()=> this.isLoading = false);

            // API処理判定
            if(apiResponseFlg){

                // 営業日の成形
                let from = new Date();
                this.dialogBusinessDay  = this.chartDateBusinessDay(from);

                this.showContent = true;
            }

        },
        dialogClose() {
            this.showContent = false;
            this.senserInputDataTemperature = '';
            this.senserInputDatahumidity = '';
            this.senserInputDataMeasurementtime = '00:00';
            this.SelectValueDialog = '';
            this.SelectValueSenser = '';
            this.validationModelMessage = "";
            this.sensorKbnName = "";
        },
        dialogOpenCheck() {

            // バリデーションチェック
            this.validationModelMessage = "";

            if(this.SelectValueDialog == '') {
                this.validationModelMessage = '種別が未選択です。'
                return ;
            }
            if(this.SelectValueSenser == '') {
                this.validationModelMessage = 'センサーが未選択です。'
                return ;
            }

            if(this.senserInputDataMeasurementtime == '') {
                this.validationModelMessage = '測定時刻が未入力です。'
                return ;
            }
            if(this.senserInputDataMeasurementtime !== '') {
                if(this.senserInputDataTemperature == '' && this.senserInputDatahumidity == '') {
                    this.validationModelMessage = '温度または湿度が未入力です。'
                    return ;
                }
            }
            if(this.senserInputDataTemperature !== '' && !this.checkTemperatureFormat(this.senserInputDataTemperature)) {
                this.validationModelMessage="温度は数値で入力してください。"
                return ;
            }
            if(this.senserInputDatahumidity !== '' && !this.checkTemperatureFormat(this.senserInputDatahumidity)) {
                this.validationModelMessage="湿度は数値で入力してください。"
                return ;
            }

            // 桁数チェック
            if(String(this.senserInputDataTemperature).length > 5 ){
                this.validationModelMessage="温度は5桁以内で入力してください。"
                return ;
            }
            if(String(this.senserInputDatahumidity).length > 5 ){
                this.validationModelMessage="湿度は5桁以内で入力してください。"
                return ;
            }

            // 桁数(小数点)チェック
            if(this.senserInputDataTemperature !== '' && this.senserInputDataTemperature.indexOf('.') !== -1){
                var array = this.senserInputDataTemperature.toString().split('.');
                if(array[1].length > 1){
                    this.validationModelMessage="温度は、小数点第1位まで入力してください。"
                    return ;
                }
            }

            // 範囲チェック 温度
            if(this.senserInputDataTemperature !== '' && this.senserInputDataTemperature !== null){
                if(this.senserInputDataTemperature  > 409.5){
                    this.validationModelMessage="温度は、409.5以下の数字を指定してください。";
                    return ;
                }
                else if(this.senserInputDataTemperature < -99.9){
                    this.validationModelMessage="温度は、-99.9以上の数字を指定してください。";
                    return ;
                }
            }
            // 範囲チェック 湿度
            if(this.senserInputDatahumidity !== '' && this.senserInputDatahumidity !== null){
                if(this.senserInputDatahumidity  > 100){
                    this.validationModelMessage="湿度は、100以下の数字を指定してください。";
                    return ;
                }
                else if(this.senserInputDatahumidity < 0){
                    this.validationModelMessage="湿度は、0以上の数字を指定してください。";
                    return ;
                }
            }

            // 営業日チェック
            if(this.dialogBusinessDay !== this.BusinessDayCheck()){
                this.validationModelMessage="入力された時刻の営業日が異なります。"
                return ;
            }

            // 相関チェック
            // 未来時刻の判定
            if(this.dateFormat() < this.dateFormat_Temperture()){
                this.validationModelMessage="計測時刻には、現在よりも過去の時刻を入力してください。"
                return ;
            }

            this.showContent = false;
            this.showContent3 = true;

            for(var i = 0 ; i < this.senserSettingsParm.length ; i++){
                if(this.senserSettingsParm[i].sensorId == this.SelectValueSenser){
                    this.senserLocation = this.senserSettingsParm[i].location
                    break;
                }
            }

        },
        dialogCloseCheck() {
            this.showContent = true;
            this.showContent3 = false;
        },
        onCloseSensorTimePicker: function () {
            const replacedTime = this.replaceTime(this.senserInputDataMeasurementtime)
            if (replacedTime) {
                this.senserInputDataMeasurementtime = replacedTime
            }
        },
        async inputSenserData() {

            this.isLoading = true;
            this.showContent3 = false;
            var apiResponseFlg = true;
            this.validationModelMessage = "";

            //重要管理項目チェック内容取得
            var brandId = this.$store.getters['brand/id'];
            var storeId = this.$store.getters['store/data'].store_id;

            var url = this.$apiEndpoint + 'user/brand/' + brandId + '/store/' + storeId + '/temperature_humidity/register';

            //更新API呼び出し
            await this.$axios
                .post(url, {
                    staff_id: this.staffId,
                    staff_name: this.staffName,
                    sensor_id: this.SelectValueSenser,
                    temperature: this.senserInputDataTemperature,
                    humidity: this.senserInputDatahumidity,
                    detection_datetime: this.nowSendDate
                })
                .then()
                .catch((err) => {
                    let error = {
                        button: {
                            path: {name: 'top', params: {brandPath: this.brandPath}}
                        }
                    }
                    apiResponseFlg = false;
                    this.isLoading = false;
                    if (err.customError) {
                        error = Object.assign(error, err.customError);

                        if (error.code == 400) {
                            this.validationModelMessage = error.message;
                            this.showContent3 = false;
                            this.showContent = true;
                        }
                    }
                    if (error.code !== 400) {
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }
                });

            // 処理エラーがない場合
            if (apiResponseFlg) {
                this.isLoading = false;
                this.showContent3 = false;
                this.showContent2 = true;
            }
        },
        replaceTime: function (v) {
            if (v === 'HH:mm') {
                return
            }
            return v.replace(/HH|mm/, '00')
        },
        // 文字種チェック 温度
        checkTemperatureFormat: function (inputData) {
            // プレースホルダ通りの入力
            if (inputData === '00.0') {
                return true
            }
            // 数値のみ受け付け
            const re = new RegExp(/^[-]?([0-9]\d*|0)(\.\d+)?$/)
            return re.test(inputData)
        },
        // 手動入力ダイアログ登録完了時 初期化処理
        closeModel: function(){
            this.showContent2 = false;
            this.validationModelMessage = "";
            this.senserInputDataTemperature = '';
            this.senserInputDatahumidity = '';
            this.senserInputDataMeasurementtime = '00:00';
            this.SelectValueDialog = '';
            this.SelectValueSenser = '';
            this.sensorKbnName = '';
        },
        // 手動入力ダイアログ表示時の営業日を設定
        chartDateBusinessDay(date){

            let year = date.getFullYear();
            let month = ("0" + (date.getMonth()+1)).slice(-2);
            let day = ("0" + date.getDate()).slice(-2);
            let hours = ("0" + date.getHours()).slice(-2);

            // AM00-AM03時の判定
            if(hours >= '00' && hours < '03'){

                // 年始の考慮
                if(month == '01' && day == '01'){
                    var yearEndDate = new Date(date.getFullYear()-1,12,0);
                    year = date.getFullYear()-1;
                    month = 12;
                    day = ("0" + yearEndDate.getDate()).slice(-2);

                }
                // 月末の考慮
                else if(day == '01'){
                    var monthEndDate = new Date(date.getFullYear(),date.getMonth(),0);
                    month = ("0" + (date.getMonth())).slice(-2);
                    day = ("0" + monthEndDate.getDate()).slice(-2);
                }
                // 前日日付の営業日
                else{
                    var dayBeforeDate = new Date(date.getFullYear(),date.getMonth()+1,date.getDate()-1);
                    day =  ("0" + dayBeforeDate.getDate()).slice(-2);
                }
            }

            let format_str = 'YYYY/MM/DD';
            format_str = format_str.replace(/YYYY/g,year);
            format_str = format_str.replace(/MM/g,month);
            format_str = format_str.replace(/DD/g,day);

            return format_str;
        },
        // 入力時刻での営業日を算出
        BusinessDayCheck(){
            let nowDate = new Date();
            var measurementTime = this.senserInputDataMeasurementtime;

            let year = nowDate.getFullYear();
            let month = ("0" + (nowDate.getMonth()+1)).slice(-2);
            let day = ("0" + nowDate.getDate()).slice(-2);
            let hours = measurementTime.substr(0,2);

            // AM00-AM03時の判定
            if(hours >= '00' && hours < '03'){

                // 年始の考慮
                if(month == '01' && day == '01'){
                    var yearEndDate = new Date(nowDate.getFullYear()-1,12,0);
                    year = nowDate.getFullYear()-1;
                    month = 12;
                    day = ("0" + yearEndDate.getDate()).slice(-2);

                }
                // 月末の考慮
                else if(day == '01'){
                    var monthEndDate = new Date(nowDate.getFullYear(),nowDate.getMonth(),0);
                    month = ("0" + (nowDate.getMonth())).slice(-2);
                    day = ("0" + monthEndDate.getDate()).slice(-2);
                }
                // 前日日付の営業日
                else{
                    var dayBeforeDate = new Date(nowDate.getFullYear(),nowDate.getMonth()+1,nowDate.getDate()-1);
                    day =  ("0" + dayBeforeDate.getDate()).slice(-2);
                }
            }
            let format_str = 'YYYY/MM/DD';
            format_str = format_str.replace(/YYYY/g,year);
            format_str = format_str.replace(/MM/g,month);
            format_str = format_str.replace(/DD/g,day);

            return format_str;
        },
        // 表示時間の生成(現在時刻、または営業日)
        fromToDataSet(){

            var toDate = "";
            var fromDate = "";

            // グラフ表示用日付 From TO の初期化
            this.lowerDataString = "";
            this.upperDataString = "";

            // 営業日がある場合、当日の営業日かを判定し、現在時刻を使用するか判定する
            if(this.date !== null){
                var nowBusinessDay = this.chartDateBusinessDay(new Date());
                var selectBusinessDay = this.selectDateFormat(this.date);
                if(nowBusinessDay === selectBusinessDay){
                    // 同じ営業日の場合、現在日時を使用
                    toDate = new Date();
                    fromDate = new Date();
                }
                else if(nowBusinessDay > selectBusinessDay){
                    // 過去の営業日の場合、指定の営業日を使用
                    let year = selectBusinessDay.substr(0,4);
                    let month = selectBusinessDay.substr(5,2);
                    let day = selectBusinessDay.substr(8,2);
                    toDate = new Date(Number(year),Number(month)-1,Number(day),2,59)
                    toDate.setDate(toDate.getDate()+1); // 営業日換算のため翌日を生成
                    fromDate = new Date(Number(year),Number(month)-1,Number(day),3,0)
                    fromDate.setDate(fromDate.getDate()+1); // 営業日換算のため翌日を生成
                }
            }
            else{
                // 現在時刻を基準時間として使用する。
                toDate = new Date();
                fromDate = new Date();
            }

            var timeRangeSelectNum = Number(this.timeRangeSelect);
            switch(timeRangeSelectNum){
                case 1:
                    // 48h
                    fromDate.setHours(fromDate.getHours()-48);
                    break;
                case 2:
                    // 24h
                    fromDate.setHours(fromDate.getHours()-24);
                    break;
                case 3:
                    // 12h
                    fromDate.setHours(fromDate.getHours()-12);
                    break;
                case 4:
                    // 6h
                    fromDate.setHours(fromDate.getHours()-6);
                    break;
                case 5:
                    // 3h
                    fromDate.setHours(fromDate.getHours()-3);
                    break;
            }

            this.setCharXAxes(fromDate, toDate);
            this.lowerDataString = this.chartDateFormat(fromDate);
            this.upperDataString = this.chartDateFormat(toDate);

        },
        // 手動入力ダイアログ 種別選択時
        changeDialogKbn(event){

            var kbn = event.target.value
            this.sensorKbnName = "";

            for(var t = 0; t < this.sensorKbnSettings.length ; t++){
                if(this.sensorKbnSettings[t].sensorKbnId == kbn){
                    this.sensorKbnName = this.sensorKbnSettings[t].sensorKbnName
                }
            }

            this.SelectValueSenser = "";
            // センサーデータを設定
            for(var i = 0 ; i < this.sensorKbnSettingsValue.length ; i++){
                if(this.sensorKbnSettingsValue[i].sensorKbnId == kbn){
                    this.senserSettingsParm = this.sensorKbnSettingsValue[i].sensorSettings;
                }
            }
        },

        //CSV出力ボタンの活性・非活性の判定
        csvButtonDisabled(){
            if(([1, 2].includes(Number(this.temperatureSelect))) && (this.isAutoSelected === true || this.isMunSelected === true) && ([1, 2, 3, 4, 5].includes(Number(this.timeRangeSelect)))){
                this.csvButtonDisabledFlg = false
            }else {
                this.csvButtonDisabledFlg = true
            }
        },
        csvButtonDisabledBusinessDay() {
            var toDate = new Date()
            toDate.setDate(toDate.getDate()-365);
            var dateFormat = this.selectDateFormat(this.date)
            if (([1, 2].includes(Number(this.temperatureSelect))) && (this.isAutoSelected === true || this.isMunSelected === true) && ([1, 2, 3, 4, 5].includes(Number(this.timeRangeSelect))) && ((this.chartDateBusinessDay(new Date())) >= dateFormat) && (dateFormat >= (this.chartDateBusinessDay(toDate)))){
                this.csvButtonDisabledFlg = false
            } else {
                this.csvButtonDisabledFlg = true
            }
        },
        async outputCsv(){
            var autoSelected = this.isAutoSelected === true ? 1 : 0;
            var munSelected = this.isMunSelected === true ? 1 : 0;
            var datetime = this.dateFormat();
            this.apivalidationMessage = '';

            var URL = this.$apiEndpoint + 'manage/brand/' + this.brandId + '/store/' + this.storeId +
                '/temperature_humidity/brandManager/csv?type=' + this.temperatureSelect
                + '&datetime=' + datetime
                + '&range=' + this.timeRangeSelect
                + '&automatic_type=' + autoSelected
                + '&manual_type=' + munSelected
                + '&sensor_kbn_id=' + this.selectValue;
            if(this.isStoreManager){
              URL = this.$apiEndpoint + 'user/brand/' + this.brandId + '/store/' + this.storeId +
                  '/temperature_humidity/csv?type=' + this.temperatureSelect
                  + '&datetime=' + datetime
                  + '&range=' + this.timeRangeSelect
                  + '&automatic_type=' + autoSelected
                  + '&manual_type=' + munSelected
                  + '&sensor_kbn_id=' + this.selectValue;
            }

            if(this.date !== null) {
                var businessDay = "";
                businessDay = this.selectDateFormat(this.date);
                URL = URL + '&businessday=' + businessDay;
            }

            await this.$axios
                .get(URL)
                .then(response => (this.csvResponseData = response))
                .catch((err) => {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}
                    if (this.auth == 4 && err.customError.code) {
                        //店舗管理者のtokenエラーの場合
                        this.$cookies.set('user-api-token', '', 0)
                        this.$store.dispatch('store/doClear')
                    }
                    if (err.customError) {
                        error = Object.assign(error, err.customError)
                    }
                    this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                }).finally(()=> this.isLoading = false)
            // CSV出力
            if(!this.commonDownloadCSV(this.csvResponseData)){
                this.apivalidationMessage =  "CSVの出力に失敗しました。";
                this.scrollTop();
            }
            else{
                this.showContent4 = true;
            }
        },

        closeModel1: function(){
            this.showContent4 = false;
        },
        isTimeEarlier(now, prev) {
          const nowDate = new Date(now);
          const prevDate = new Date(prev);
          const diffInMs = Math.abs(prevDate.getTime() - nowDate.getTime());
          const fifteenMinutesInMs = 15 * 60 * 1000;
          return diffInMs >= fifteenMinutesInMs;
        },
        findMaxMin(datasets) {
          var minDatasets = datasets[0];
          var maxDatasets = datasets[0];
          datasets.forEach(datasets => {
            if(datasets.label == 'upper' && datasets.hidden == false) {

              if(datasets['data'][0]['y'] > maxDatasets['data'][0]['y']) {
                maxDatasets = datasets;
              }
            }
            if(datasets.label == 'lower' && datasets.hidden == false) {
              if(datasets['data'][0]['y'] < minDatasets['data'][0]['y']) {
                minDatasets = datasets;
              }
            }
          });
          return { max:maxDatasets['data'][0]['y'], min:minDatasets['data'][0]['y'] };
        },
        isToday() {
          const today = new Date();
          return (
              today.getFullYear() === this.date.getFullYear() &&
              today.getMonth() === this.date.getMonth() &&
              today.getDate() === this.date.getDate()
          );
        },
        async sensorSearch(sensorID){
          if(sensorID === '' || sensorID === undefined || sensorID === null) {
            this.ApivalidationMessage = 'センサーIDが入力されていません。';
            this.scrollTop();
            return;
          }
          this.inputSensorQuery = sensorID;
          var dataSetsListObj = new Object();
          dataSetsListObj['labels'] = [];
          dataSetsListObj['datasets'] = this.tempSenserData['datasets'].filter(e => {
            //閾値ラベル等は除外
            if (e['sensorId'] === undefined || e['sensorId'] === null) return true;
            //センサーIDから自動・手動のテキストを除外
            const id = e['sensorId'][0];
            const loc = e['location'][0];
            //IDと設置名称の判定
            const isIdMatch = id.includes(this.inputSensorQuery);
            const isLocationMatch = loc.includes(this.inputSensorQuery);
            //不一致
            if (!isIdMatch && !isLocationMatch) return false;
            //異常フィルター適用
            switch (this.selectAccident) {
              case 1:
                return e['sensorAccidentFlg'] == 1;
              case 2:
                return e['temperatureAccidentFlg'] == 1;
              case 0:
              default:
                return true;
            }
          });
          this.senserData = dataSetsListObj;
        },
        async resetSearch(){
          this.inputSensorQuery = '';
          var dataSetsListObj = new Object();
          dataSetsListObj['labels'] = [];
          dataSetsListObj['datasets'] = this.tempSenserData['datasets'].filter(e => {
            //異常フィルター適用
            switch (this.selectAccident) {
              case 1:
                return e['sensorAccidentFlg'] == 1;
              case 2:
                return e['temperatureAccidentFlg'] == 1;
              case 0:
              default:
                return true;
            }
          });
          this.senserData = dataSetsListObj;
        },

    },
    watch:{
        // 営業日の変更を監視
        date:function(){
            var selectBusinessDay = "";
            var nowBusinessDay = "";
            // 営業日の選択有無をチェック
            if(this.date !== null){
                // 営業日が選択されている場合
                selectBusinessDay= this.selectDateFormat(this.date);
                nowBusinessDay = this.chartDateBusinessDay(new Date());

                // 当日または未来の営業日を選択している場合
                if(selectBusinessDay>= nowBusinessDay){
                    this.timeRangeFlg = true;
                }
                // 過去の営業日を選択している場合
                if(selectBusinessDay< nowBusinessDay){
                    this.timeRangeFlg = false;
                    // 選択中の表示期間が12h～3hの場合、強制的に24hを選択
                    if(this.timeRangeSelect == 3 || this.timeRangeSelect == 4 || this.timeRangeSelect == 5){
                        this.timeRangeSelect = 2;
                    }
                }
            }
            else{
                // 表示期間の制御
                this.timeRangeFlg = true;
            }
            this.changeKbn("event","check")
            this.csvButtonDisabledBusinessDay(this.csvButtonDisabledFlg);
        },
        setRequestManager: function (kbn) {
          // 権限区分ごとに設定
          switch (kbn) {
            case 1:
              //システム管理者
              return false;
            case 2:
              //企業管理者
              return false;
            case 3:
              //店舗管理者（共通）
              return false;
            case 4:
              //店舗管理者（個別）
              return true;
          }
        },

    }
}
</script>